'use client';

import {useState} from 'react';
import {SignupForm, type SignupFormProps} from 'iq-auth/components/signup_form';
import {LoginForm, type LoginFormProps} from 'iq-auth/components/login_form';

// Every form prop except the mode-switch callbacks that AuthForm injects itself.
type AuthFormProps = Omit<SignupFormProps & LoginFormProps, 'onSwitchToLogin' | 'onSwitchToSignup'>;

export function AuthForm(props: AuthFormProps) {
  const [mode, setMode] = useState<'signup' | 'login'>('signup');

  if (mode === 'login') {
    return <LoginForm {...props} onSwitchToSignup={() => setMode('signup')} />;
  }

  return <SignupForm {...props} onSwitchToLogin={() => setMode('login')} />;
}
